import { Injectable } from '@angular/core';
import { FinanceiroMovimentoModel, FinanceSaudeModel, FinanceSaudeQueryPayload, PlanoContaModel } from '@app/data';
import { ApiService } from '@app/gateway';
import type { DashPeriodQueryPayload } from '@app/pages/dashboard/shared';

@Injectable({ providedIn: 'root' })
export class FinanceiroService {
  constructor(protected readonly apiService: ApiService) {}

  public async planoConta(data: Pick<DashPeriodQueryPayload, 'idAccounts'>): Promise<PlanoContaModel[]> {
    try {
      const path: string = `financeiro/planoConta`;
      const result: PlanoContaModel[] = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load chart of accounts.';
      throw new Error(message, { cause: e });
    }
  }

  public async dre(data: DashPeriodQueryPayload): Promise<FinanceiroMovimentoModel[]> {
    try {
      const path: string = `financeiro/dre`;
      const result: FinanceiroMovimentoModel[] = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load DRE.';
      throw new Error(message, { cause: e });
    }
  }

  public async fluxoCaixa(data: DashPeriodQueryPayload): Promise<FinanceiroMovimentoModel[]> {
    try {
      const path: string = `financeiro/fluxoCaixa`;
      const result: FinanceiroMovimentoModel[] = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load cash flow.';
      throw new Error(message, { cause: e });
    }
  }

  /** Unified financial health facade — one round-trip for position, aging and daily cash flow. */
  public async saude(data: FinanceSaudeQueryPayload): Promise<FinanceSaudeModel> {
    try {
      const path: string = `financeiro/saude`;
      const result: FinanceSaudeModel = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load financial health dashboard.';
      throw new Error(message, { cause: e });
    }
  }
}
